

(function () {
    window.dataLayer = window.dataLayer || [];

    let addTriggers = document.querySelectorAll('[data-ga4-trigger="add"]');

    for (var i = 0; i < addTriggers.length; i++) {
        addG4aData(addTriggers[i]);
    }

    let clickTriggers = document.querySelectorAll('[data-ga4-trigger="click"]');

    for (var i = 0; i < clickTriggers.length; i++) {
        clickTriggers[i].addEventListener('click', function (event) {
            window.Ga4Trigger(event.currentTarget);
        });
    }

    window.onload = function () {
        let loadTriggers = document.querySelectorAll('[data-ga4-trigger="load"]');

        for (var i = 0; i < loadTriggers.length; i++) {
            window.Ga4Trigger(loadTriggers[i]);
        }

        onScroll();
    }

    document.addEventListener('scroll', onScroll);

    function addG4aData(target) {
        let links = target.querySelectorAll('a');

        for (var i = 0; i < links.length; i++) {
            if (links[i].href.indexOf("#") > -1) {
                links[i].dataset["ga4Trigger"] = "click";
                links[i].dataset["ga4Event"] = "open_form";
                links[i].dataset["ga4Service_type"] = decodeURI(links[i].href.split("#")[1]);
                links[i].dataset["ga4Location"] = "Body";
            }
            else {
                links[i].dataset["ga4Trigger"] = "click";
                links[i].dataset["ga4Event"] = "select_content";
                links[i].dataset["ga4Content_type"] = "Servicesida";
                links[i].dataset["ga4Item_name"] = links[i].innerHTML;

            }

        }
    }

    function onScroll() {
        let showTriggers = document.querySelectorAll('[data-ga4-trigger="show"]');

        for (var i = 0; i < showTriggers.length; i++) {
            if (isInViewport(showTriggers[i]) && !showTriggers[i].dataset['shown']) {
                showTriggers[i].dataset['shown'] = true;
                window.Ga4Trigger(showTriggers[i]);
            }
        }
    }

    function isInViewport(element) {
        const rect = element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }
})();

window.Ga4Trigger = function (target) {
    var dl = {}

    for (const key in target.dataset) {
        if (key.startsWith('ga4') && key != "ga4Trigger") {
            if (key == "ga4Event")
                if (target.dataset["ga4Event"] == "open_form" || target.dataset["ga4Event"] == "select_promotion")
                window.OpenFormButtonText = target.dataset["ga4Button_location"];

            if (key.match('ga4Ri(.+)')) {
                var value = target.dataset[key]
                var m = key.match('ga4Ri(.+)');
                if (m && m[1]) {
                    if (!dl['request_info'])
                        dl['request_info'] = {};

                    dl['request_info'][m[1].toLowerCase()] = value;
                }
            }
            else {
                var value = target.dataset[key];

                if (value == "[saved_location]")
                    value = window.OpenFormButtonText || "";

                dl[key.replace('ga4', '').toLowerCase()] = value;

            }
        }
    }

    window.dataLayer.push(dl);
}





